import { QueryBuilder } from '@mui/icons-material';
import { useAppSelector } from 'app/hooks';
import FlightRouteCardDetails from 'components/Flight/FlightList/FlightRouteCardDetails';
import { differenceInMinutes } from 'date-fns';
import { durationToTime } from 'helper/date';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { changeFlightBookSteps, complementaryFormDataState } from 'store/flight/flightSlice';
import { userInfoState } from 'store/userInfo/userInfoSlice';
import FlightCardAmountBlock from '../FlightCardAmountBlock';
import * as S from './FlightCard.styles';
import { FlightCardProps } from './flightcard.interface';

const FlightCard = ({ flight, discountTicketId }: FlightCardProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { departureText, destinationText } = useAppSelector(complementaryFormDataState);
  const { originDestinationOption } = flight;
  const userInfo = useAppSelector(userInfoState);

  const flightStops =
    originDestinationOption[0].flightSegment.length === 1
      ? t('pages.services.flight.constants.stops.direct')
      : originDestinationOption[0].flightSegment.length === 2
      ? t('pages.services.flight.constants.stops.oneStop')
      : t('pages.services.flight.constants.stops.moreThanOneStop', {
          count: originDestinationOption[0].flightSegment.length,
        });

  const selectFlight = () => {
    dispatch(changeFlightBookSteps(1));
  };

  return (
    <S.Wrapper>
      <S.DetailsWrapper>
        {originDestinationOption.map((e, i) => {
          return (
            <S.Details key={i}>
              <S.Flys>
                <FlightRouteCardDetails
                  time={e.flightSegment[0].departureDateTime}
                  airport={e.flightSegment[0].departureAirport}
                />
                <S.SmallText>{i === 0 ? departureText : destinationText}</S.SmallText>
                <S.FlightNumber>{e.flightSegment[0].flightNumber}</S.FlightNumber>
              </S.Flys>
              <S.DetailsCenterBlock>
                <S.DetailsCenterBlockIcon>
                  <QueryBuilder width="20" height="20" />
                </S.DetailsCenterBlockIcon>
                <S.TinyText>
                  {durationToTime(
                    differenceInMinutes(
                      e.flightSegment[e.flightSegment.length - 1].arrivalDateTime,
                      e.flightSegment[0].departureDateTime
                    )
                  )}
                </S.TinyText>
                <S.TinyText>{flightStops}</S.TinyText>
              </S.DetailsCenterBlock>
              <S.Flys>
                <FlightRouteCardDetails
                  time={e.flightSegment[e.flightSegment.length - 1].arrivalDateTime}
                  airport={e.flightSegment[e.flightSegment.length - 1].arrivalAirport}
                />
                <S.SmallText>{i === 0 ? destinationText : departureText}</S.SmallText>
              </S.Flys>
            </S.Details>
          );
        })}
      </S.DetailsWrapper>

      <S.AmountBlockWrapper>
        <FlightCardAmountBlock
          flight={flight}
          availType="business"
          availClass="Z1"
          cabinClassTitle={t('constants.cabinClasses.business')}
          userTierMilage={userInfo.data?.rewardMilage || 0}
          onSelect={selectFlight}
          discountTicketId={discountTicketId}
        />
        <FlightCardAmountBlock
          flight={flight}
          availType="economy"
          availClass="H1"
          cabinClassTitle={t('constants.cabinClasses.economy')}
          userTierMilage={userInfo.data?.rewardMilage || 0}
          onSelect={selectFlight}
          discountTicketId={discountTicketId}
        />
      </S.AmountBlockWrapper>
    </S.Wrapper>
  );
};

export default FlightCard;
